import { memo, useMemo } from 'react';

import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite';
import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import getSecondaryNavParentList from '@/state/selectors/secondary-nav/get-secondary-nav-parent-list';
import { SecondaryNavLink } from '@/state/slices/secondary-nav/typings';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbContentProps extends BasicComponentProps {
	subnavItem: SecondaryNavLink;
	index: number;
}

const BreadcrumbContentItemComponent: React.FC<BreadcrumbContentProps> = ({
	subnavItem,
	index,
}) => {
	const secondaryNavParentList = useStore(getSecondaryNavParentList);
	const currentPath = useMemo(() => subnavItem.path, [subnavItem]);
	const currentLink = useMemo(() => subnavItem.link, [subnavItem]);

	const isSelected = useMemo(
		() =>
			secondaryNavParentList?.some(
				(item, i) =>
					i > index &&
					(item.path === currentPath || item.link === currentLink),
			),
		[secondaryNavParentList, currentPath, currentLink],
	);

	return (
		<li
			key={`${subnavItem.title}_${subnavItem.evaluatedLink}`}
			className='dxnav__breadcrumb-dropdown-item'
		>
			<a
				className={
					isSelected
						? 'dxnav__breadcrumb-dropdown-link dxnav-selected'
						: 'dxnav__breadcrumb-dropdown-link'
				}
				href={subnavItem.evaluatedLink}
			>
				<span className='dxnav__breadcrumb-text'>
					{subnavItem.title}
				</span>
				{subnavItem.hasMultipleChildren ? (
					<SvgSprite
						icon={IconNames.CHEVRON_RIGHT}
						$width={10}
						$height={10}
					/>
				) : null}
			</a>
		</li>
	);
};

const BreadcrumbContentItem = memo(
	withExposer(BreadcrumbContentItemComponent, 'breadcrumb_content_item'),
);

export default BreadcrumbContentItem;
